import * as DATAHUB from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

import { SALES_BANNER_STEPS } from './constants';

const SALES_EVENTS_NAME = {
  [SALES_BANNER_STEPS.MAKE_SALES]: DATAHUB.NAMES.CARD_MAKE_SALES
};

const ANALYTICS_EVENTS = GtagService.createEvents({
  common: {
    name: GA.CATEGORIES.SALES_DASHBOARD,
    category: GA.CATEGORIES.SALES_DASHBOARD
  },
  [SALES_BANNER_STEPS.MAKE_SALES]: {
    action: GA.ACTIONS.LEARN_MORE
  },
  [GA.ACTIONS.HELP_CENTER]: {
    action: GA.ACTIONS.HELP_CENTER
  },
  [GA.ACTIONS.BLOG_LINK]: {
    action: GA.ACTIONS.BLOG_LINK
  },
  [GA.ACTIONS.USERS]: {
    action: GA.ACTIONS.USERS
  },
  [GA.ACTIONS.MARKETING_BANNER]: {
    action: GA.ACTIONS.MARKETING_BANNER,
    label: GA.LABELS.START_NOW
  }
});

const sendMetrify = (eventName, marketplaceId) =>
  DatahubService.sendMetrify({
    group: DATAHUB.GROUPS.SALES_DASHBOARD,
    name: eventName,
    user: { id: marketplaceId }
  });

export default {
  clickOnSalesCardButton: (step, marketplaceId) => {
    if (SALES_BANNER_STEPS[step]) {
      const eventDataHub = SALES_EVENTS_NAME[step];
      const eventAnalytics = ANALYTICS_EVENTS[step];

      eventDataHub && sendMetrify(eventDataHub, marketplaceId);

      eventAnalytics && GtagService.send(eventAnalytics);
    }
  },
  clickOnBlogLink: (marketplaceId) => {
    const event = ANALYTICS_EVENTS[GA.ACTIONS.BLOG_LINK];

    sendMetrify(DATAHUB.NAMES.BLOG_LINK, marketplaceId);

    event && GtagService.send(event);
  },
  clickOnHelpCenterLink: (marketplaceId) => {
    const event = ANALYTICS_EVENTS[GA.ACTIONS.HELP_CENTER];

    sendMetrify(DATAHUB.NAMES.HELP_CENTER, marketplaceId);

    event && GtagService.send(event);
  },
  clickOnUserButton: (marketplaceId) => {
    const event = ANALYTICS_EVENTS[GA.ACTIONS.USERS];

    sendMetrify(DATAHUB.NAMES.USERS, marketplaceId);

    event && GtagService.send(event);
  },
  clickOnMarketingBanner: (marketplaceId) => {
    const event = ANALYTICS_EVENTS[GA.ACTIONS.MARKETING_BANNER];

    sendMetrify(DATAHUB.NAMES.MARKETING_BANNER, marketplaceId);

    event && GtagService.send(event);
  }
};
